// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 获取过磅列表
export function getList(data) {
  const url = global.requestUrl + '/log/userLog?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&username=' + data.username
  return axios.get(url)
}

